import { useMemo, useState } from 'react';

import LanguageContext from './LanguageContext.js';

export const LanguageProvider: React.FC<{
  children: React.ReactNode;
  defaultLocale?: string;
}> = ({ children, defaultLocale }) => {
  const [locale, setLocale] = useState<string | null>(null);

  const value = useMemo(
    () => ({
      setLocale,
      defaultLocale,
      locale,
    }),
    [defaultLocale, locale]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
